import React, { ReactNode, useId } from "react";
import { AccordionItemProvider } from "./providers";

import { Optional } from "../../types";
import styles from "./accordion-item.module.css";

export type AccordionItemProps = {
  children: ReactNode;
  defaultOpen?: Optional<boolean>;
  name?: string;
} & React.AllHTMLAttributes<HTMLDivElement>;

export function AccordionItem({ children, ...props }: AccordionItemProps) {
  return (
    <section className={styles.Main} {...props}>
      {children}
    </section>
  );
}

export function AccordionItemWithProvider({
  children,
  name,
  defaultOpen,
  ...props
}: AccordionItemProps) {
  const id = useId();

  return (
    <AccordionItemProvider defaultOpen={defaultOpen ?? false} name={name ?? id}>
      <AccordionItem {...props}>{children}</AccordionItem>
    </AccordionItemProvider>
  );
}
